export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-queue/index.js
// module id = 704
// module chunks = 0